// TOEFL iBT Mock 1 — Speaking (2026 format)
//
// 1. Listen and Repeat  – hear a sentence once, then repeat it exactly.
// 2. Take an Interview  – answer four questions, 45 seconds each, no prep time.

export const listenRepeat = {
  context:
    "You are training to be a tour guide at a city history museum. Listen to your supervisor and repeat exactly what you hear.",
  speakerGender: "f",
  sentences: [
    "Welcome to the museum.",
    "Please keep your ticket with you.",
    "The tour begins in the main hall.",
    "Photos are allowed, but please don't use a flash.",
    "This painting shows the harbor as it looked two centuries ago.",
    "If you need help, ask any member of staff wearing a blue badge.",
    "Before you leave, remember to visit the gift shop on the ground floor.",
  ],
};

export const interview = {
  context:
    "You have agreed to take part in a research study about how people use public spaces in cities. A researcher will ask you four questions. Answer each question as fully as you can. You have 45 seconds for each answer.",
  speakerGender: "m",
  responseSeconds: 45,
  questions: [
    {
      text: "Thank you for joining us. To start, can you tell me about a public place in your city, such as a park or a square, that you visit often? What do you usually do there?",
      keywords: ["park", "square", "visit", "walk", "go", "place", "city", "garden", "friends", "relax", "weekend", "beach", "library", "market"],
    },
    {
      text: "Some people say that cities should replace parking spaces with parks and bicycle lanes. Do you agree or disagree with this idea? Why?",
      keywords: ["parking", "park", "parks", "bicycle", "bike", "lanes", "cars", "car", "traffic", "agree", "disagree", "space", "city", "pollution", "people"],
    },
    {
      text: "Many cities now hold events like outdoor concerts and markets in public spaces. How do these events affect the people who live nearby?",
      keywords: ["event", "events", "concert", "concerts", "market", "markets", "noise", "people", "neighbors", "residents", "nearby", "business", "community", "crowd", "fun"],
    },
    {
      text: "Finally, if you could design a new public space for young people in your city, what would it include, and why?",
      keywords: ["design", "include", "young", "space", "sports", "study", "wifi", "games", "court", "music", "art", "would", "because", "teenagers", "students"],
    },
  ],
};
